import React, { useState } from "react";
import PropTypes from "prop-types";
import _ from 'lodash';
import Select from '@material-ui/core/Select';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import OutlinedInput from "@material-ui/core/OutlinedInput";
import MenuItem from "@material-ui/core/MenuItem";
import { StyledFormControl, StyledSelect, StyledListItemText } from './style';
import TypographyParagraph from '../../../../../../TypographyParagraph';


function PeriodSelect(props) {
  const { selectablePeriods, reportPeriod, setReportPeriod } = props;
  const [menuOpen, setMenuOpen] = useState(false);

  const handleReportPeriodChange = (event, element) => {
    setReportPeriod(event.target.value);
  }

  const handleReportPeriodMenu = () => {
    setMenuOpen(!menuOpen);
  }

  const renderValue = period => {
    return <TypographyParagraph>{period}</TypographyParagraph>;
  }

  const sortPeriods = (unsortedPeriods) => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    return unsortedPeriods.map( selectablePeriod => {
        const parts = selectablePeriod.split(" ");
        return {
            month: months.indexOf(parts[0]),
            year: parts[1],
            original: selectablePeriod
        }
    }).sort( (a,b) => {
        return new Date(a.year, a.month) - new Date(b.year, b.month)
    }).map( final => final.original);
  }

  const sortedSelectablePeriods = sortPeriods(selectablePeriods);
  return (
    <StyledFormControl variant="outlined" >
      <StyledSelect
        value={reportPeriod}
        renderValue={selectedPeriod => renderValue(selectedPeriod)}
        onChange={handleReportPeriodChange}
        onOpen={handleReportPeriodMenu}
        onClose={handleReportPeriodMenu}
        input={<OutlinedInput autoFocus={false} />}
        IconComponent={ExpandMoreIcon}
        MenuProps={{
          getContentAnchorEl: null,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          }
        }}
      >
        {sortedSelectablePeriods && sortedSelectablePeriods.length > 1 && 
          sortedSelectablePeriods.map((period, i) => (
            <div key={`${period}-${i}`} value={period}>
              {period !== reportPeriod && (
                <MenuItem disableRipple>
                  <StyledListItemText>{period}</StyledListItemText>
                </MenuItem>
              )}
            </div>
          ))
        }
      </StyledSelect>
    </StyledFormControl>
  );
}

PeriodSelect.propTypes = {
  /** Array of all surveyPeriods from the summaryReportTree */
  selectablePeriods: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default PeriodSelect;



// WEBPACK FOOTER //
// ./src/components/SRHHeaders/SummaryReportHeader/components/SwitchReport/components/PeriodSelect/index.jsx